import { LineWoSchedule } from "../types/lineWoSchedule";
import { aplClient } from "./apiClient";

const getSchedules = (lineId: number) => {
    return aplClient().get(`lineWoSchedules/${lineId}`);
};

const saveSchedule = (schedule: LineWoSchedule) => {
    return aplClient().post(`lineWoSchedules`, schedule);
};

const changeScheduleOrder = (schedule: LineWoSchedule, shift: number) => {
    return aplClient().put(`lineWoSchedules/${schedule.scheduleId}`, shift);
};

const deleteSchedule = (scheduleId: string) => {
    return aplClient().delete(`lineWoSchedules/${scheduleId}`);
};

export { getSchedules, saveSchedule, changeScheduleOrder, deleteSchedule };
